export default __webpack_public_path__ + "img/84725b04cd99511989cfb2605413ed07.svg";